/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBusinessRequest
 */
export interface UpdateBusinessRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBusinessRequest
     */
    display_name: string;
}

/**
 * Check if a given object implements the UpdateBusinessRequest interface.
 */
export function instanceOfUpdateBusinessRequest(value: object): value is UpdateBusinessRequest {
    if (!('display_name' in value) || value['display_name'] === undefined) return false;
    return true;
}

export function UpdateBusinessRequestFromJSON(json: any): UpdateBusinessRequest {
    return UpdateBusinessRequestFromJSONTyped(json, false);
}

export function UpdateBusinessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBusinessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'display_name': json['display_name'],
    };
}

export function UpdateBusinessRequestToJSON(json: any): UpdateBusinessRequest {
    return UpdateBusinessRequestToJSONTyped(json, false);
}

export function UpdateBusinessRequestToJSONTyped(value?: UpdateBusinessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_name': value['display_name'],
    };
}

